import { useMutation, useQuery } from '@apollo/client'
import { useSnackbar } from '@components/Snackbar/SnackbarProvider'
import { GET_PRO, SEND_ACTIVATION_EMAIL_PRO } from '@gql/pros'
import EmailIcon from '@mui/icons-material/Email'
import { Box, Button, CircularProgress, Grid, Stack } from '@mui/material'
import { useParams } from 'react-router-dom'
import CompanyAboutForm from './forms/CompanyAboutForm'
import CompanyAdministrativeForm from './forms/CompanyAdministrativeForm'
import { CompanyPhotosCard, CompanyVideosCard } from './forms/CompanyBrandForm'
import CompanyOwnerForm from './forms/CompanyOwnerForm'
import CompanyContactsCard from './components/CompanyContactsCard'
import CompanyGeoLocationCard from './components/CompanyGeoLocationCard'
import CompanyProfileCompletion from './components/CompanyProfileCompletion'

function CompanyEdit() {
  const { id } = useParams<{ id: string }>()
  const { showSnackbar } = useSnackbar()

  const { data, loading, refetch } = useQuery(GET_PRO, {
    variables: { proId: id },
    skip: !id,
  })

  const [sendActivationEmail, { loading: sendingEmail }] = useMutation(SEND_ACTIVATION_EMAIL_PRO)

  const pro = data?.getPro

  const handleSuccess = (data?: any) => {
    showSnackbar(data?.message || "Mise à jour réussie.", 'success')
    refetch()
  }

  const handleError = (error?: any) => {
    showSnackbar(error?.message || "Une erreur est survenue.", 'error')
    console.error(error)
  }

  const handleSendActivationEmail = async () => {
    try {
      await sendActivationEmail({ variables: { proId: id } })
      showSnackbar("Email d'activation envoyé avec succès.", 'success')
    } catch (err: any) {
      showSnackbar(err?.message || "Erreur lors de l'envoi de l'email.", 'error')
    }
  }

  if (loading || !pro) {
    return <CircularProgress />
  }

  return (
    <Grid container sx={{flex: 1, width:  "100%"}} spacing={4}>
      <Grid item xs={12} md={8}>
        <Stack spacing={4}>
        <CompanyAboutForm
          pro={pro}
          onSuccess={handleSuccess}
          onError={handleError}
          isEdit
        />

        <CompanyPhotosCard
          pro={pro}
          onSuccess={handleSuccess}
          onError={handleError}
          isEdit
        />

        <CompanyVideosCard
          pro={pro}
          onSuccess={handleSuccess}
          onError={handleError}
          isEdit
        />

        <CompanyAdministrativeForm
          pro={pro}
          onSuccess={handleSuccess}
          onError={handleError}
          isEdit
        />

        <CompanyOwnerForm
          pro={pro}
          onSuccess={handleSuccess}
          onError={handleError}
          isEdit
        />
        </Stack>
      </Grid>
      <Grid item xs={12} md={4}>
        <Stack spacing={4}>
          <CompanyProfileCompletion pro={pro} />
          <CompanyContactsCard pro={pro} />
          <CompanyGeoLocationCard pro={pro} />
         {!pro.onboardingCompleteDate && <Button
            startIcon={sendingEmail ? <CircularProgress size={16} /> : <EmailIcon />}
            onClick={handleSendActivationEmail}
            disabled={sendingEmail}
            size="large"
            fullWidth>
            Envoyer l&apos;email d&apos;activation
          </Button>}
        </Stack>
      </Grid>
    </Grid>
  )
}

export default CompanyEdit
